// src/components/CookieBanner.jsx

import { useState, useEffect } from "react";

const CookieBanner = ({ language = "ru" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("tcm-cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("tcm-cookie-consent", "accepted");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const text = language === "ru"
    ? {
        title: "Мы используем cookie",
        description:
          "Сайт использует cookie для аналитики и улучшения работы. Продолжая использовать сайт, вы соглашаетесь с ",
        accept: "Принять",
        settings: "Настроить",
        policyLink: "Политикой конфиденциальности"
      }
    : {
        title: "We use cookies",
        description:
          "This site uses cookies for analytics and improvement. By continuing, you agree to our ",
        accept: "Accept",
        settings: "Settings",
        policyLink: "Privacy Policy"
      };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        color: "white",
        padding: "1rem",
        zIndex: 9999,
        boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(255, 255, 255, 0.1)"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "0.75rem"
        }}
      >
        <div style={{ flex: "1 1 300px" }}>
          <p
            style={{
              margin: 0,
              fontSize: "0.8125rem",
              lineHeight: 1.5,
              opacity: 0.9
            }}
          >
            {text.description}{" "}
            <a
              href="/privacy"
              style={{
                color: "#60a5fa",
                textDecoration: "underline",
                cursor: "pointer"
              }}
            >
              {text.policyLink}
            </a>
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            flexShrink: 0,
            marginTop: "0.25rem"
          }}
        >
          <button
            onClick={() => setIsVisible(false)}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "transparent",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
              fontSize: "0.8125rem",
              fontWeight: 500,
              transition: "all 0.2s"
            }}
          >
            {text.settings}
          </button>
          <button
            onClick={acceptCookies}
            style={{
              padding: "0.5rem 1.25rem",
              backgroundColor: "#3b82f6",
              border: "none",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
              fontSize: "0.8125rem",
              fontWeight: 600,
              transition: "all 0.2s"
            }}
          >
            {text.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
